export default "__VITE_ASSET__BMKsR2Lu__"